import React, { useEffect, useRef } from "react";

const ManualBarChart = ({ data }) => {
  const canvasRef = useRef(null);

  const drawEllipsisText = (ctx, text, x, y, maxWidth) => {
    let ellipsis = "...";
    let width = ctx.measureText(text).width;

    if (width <= maxWidth) {
      ctx.fillText(text, x, y);
      return;
    }

    while (text.length > 0 && ctx.measureText(text + ellipsis).width > maxWidth) {
      text = text.slice(0, -1);
    }

    ctx.fillText(text + ellipsis, x, y);
  };

  useEffect(() => {
    if (!Array.isArray(data)) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const barHeight = 30;
    const gap = 15;
    const labelWidth = 300;
    const maxValue = Math.max(
      ...data.map((d) => Number(d.finished) + Number(d.not_start))
    );

    canvas.width = 900;
    canvas.height = data.length * (barHeight + gap);
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.font = "14px Arial";
    ctx.textAlign = "left";

    data.forEach((item, index) => {
      const y = index * (barHeight + gap);
      const finished = Number(item.finished);
      const notStart = Number(item.not_start);

      const barFullWidth = canvas.width - labelWidth - 40;
      const finishedWidth = (finished / maxValue) * barFullWidth;
      const notStartWidth = (notStart / maxValue) * barFullWidth;

      // Label with ellipsis
      ctx.fillStyle = "#000";
      const labelText = item.attribute_6.replace(/&amp;/g, "&");
      drawEllipsisText(ctx, labelText, 10, y + barHeight - 10, labelWidth - 20);

      // Finished bar
      ctx.fillStyle = "#4caf50";
      ctx.fillRect(labelWidth, y, finishedWidth, barHeight);
      if (finished > 0) {
        ctx.fillStyle = "#fff";
        ctx.fillText(finished, labelWidth + 5, y + barHeight - 10);
      }

      // Not started bar
      ctx.fillStyle = "#f44336";
      ctx.fillRect(labelWidth + finishedWidth, y, notStartWidth, barHeight);
      if (notStart > 0) {
        ctx.fillStyle = "#fff";
        ctx.fillText(notStart, labelWidth + finishedWidth + 5, y + barHeight - 10);
      }
    });
  }, [data]);

  return (
    <div style={{ maxHeight: "320px", overflowY: "auto" }}>
      <canvas ref={canvasRef} />
    </div>
  );
};

export default ManualBarChart;
